import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export function useBreakpoints() {
  const { width } = useWindowDimensions();

  const isSmall = width >= 640;
  const isMedium = width >= 768;
  const isLarge = width >= 1024;
  const isXLarge = width >= 1280;
  const is2XLarge = width >= 1536;

  return {
    isSmall,
    isMedium,
    isLarge,
    isXLarge,
    is2XLarge,
  };
}
